import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Tooltip from "./tooltip";

const Container = styled.tr`
  font-size: 12px;
  box-sizing: border-box;
`;

const LabelWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 2px 10px;
  border: 0.3px solid rgba(98, 100, 105, 0.2);
  background: #e7e6e6;
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
`;

const Label = styled.span`
  color: #0f0f0f;
  white-space: nowrap;
`;

const QuantityLabel = styled.span`
  font-size: 16px;
  font-weight: 700;
  margin-left: 5px;
`;

const Cell = styled.td`
  padding-top: 5px;
  vertical-align: middle;
`;

const QuantityCell = styled(Cell)`
  width: 100%;
`;

const QuantityAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #0F81B3;
  ${(props) => (props.error ? `color: #B10043;` : ``)}
`;

const IconWrapper = styled.div`
  margin-left: 5px;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
`;

const TooltipContent = styled.div`
  display: flex;
  padding: 16px;
  width: 200px;
  border-radius: 4px;

`;

const TooltipLabel = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 400;
  white-space: pre-wrap;
`;

class Capacity extends React.Component {
  static propTypes = {
    capacity: PropTypes.object,
  };

  renderIcon = (status) => {
    if (status === "error") {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
          <path fill="currentColor" d="M512 128c212 0 384 172 384 384S724 896 512 896 128 724 128 512s172-384 384-384zm0 43c-189 0-341 152-341 341s152 341 341 341 341-152 341-341-152-341-341-341zm-32 107c-8 8-11 20-11 31l11 249c0 9 3 18 10 24 6 5 14 8 22 8 9 0 17-3 23-8 6-6 10-15 9-24l13-249c0-12-5-23-13-31-9-9-20-13-32-13s-24 4-32 13zm67 469v-1c10-9 16-22 15-36 0-13-5-26-15-35-9-9-22-15-35-14-14-1-26 5-36 14-9 9-15 22-14 35-1 14 5 28 15 37 20 18 50 18 70 0z" />
        </svg>
      );
    }

    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
        <path
          fill="currentColor"
          d="M576.8,661.2c-29.3,39.1-96.4,89.5-158.1,89.5c-19.6,0-34.7-21.1-34.7-30.1c0-8.3,3.1-17.3,9.2-32.4l78.3-187.4  c2.2-6.1,2.2-10.5-1.5-10.5c-12.8,0-55,31.5-67.1,42.9c-9-1.5-15.1-11.4-12-18.1c40.7-49.6,111.5-86.5,151.4-86.5  c16.6,0,34.6,16.5,34.6,33.1c0,7.5-5.3,21.8-9.7,33.1l-78.4,184.5c-3,6.8-2.3,11.2,3,11.2c10.5,0,51.9-29.3,70.8-47.4  c8.1-0.1,14.7,6.4,14.7,14.5C577.3,658.8,577.1,660.1,576.8,661.2z M578.5,396.1c-33.9,0-61.4-27.5-61.4-61.5s27.5-61.4,61.5-61.4  c33.9,0,61.4,27.5,61.4,61.4C640,368.6,612.5,396.1,578.5,396.1C578.6,396.1,578.6,396.1,578.5,396.1L578.5,396.1z"
        />
        <path
          fill="currentColor"
          d="M512,171c188,0,341,153,341,341S700,853,512,853S171,700,171,512S324,171,512,171 M512,128c-211.8,0-384,172.3-384,384  s172.2,384,384,384s384-172.3,384-384S723.8,128,512,128z"
        />
      </svg>
    );
  };

  renderToggle = (status) => {
    return (<IconWrapper>{this.renderIcon(status)}</IconWrapper>);
  }

  renderTooltipContent = () => {
    return (
      <TooltipContent>
        <TooltipLabel>
          {this.props.capacity?.additionalInformation}
        </TooltipLabel>
      </TooltipContent>
    );
  }

  render = () => {
    const currentValue = this.props.capacity?.currentValue || 0;
    const maxValue = this.props.capacity?.maxValue || 0;

    const status = currentValue >= maxValue ? "error" : "normal";

    return (
      <Container>
        <Cell>
          <LabelWrapper>
            <Label>{this.props.capacity?.label}</Label>
          </LabelWrapper>
        </Cell>
        <QuantityCell>
          <QuantityAndIconWrapper error={currentValue >= maxValue}>
            <QuantityLabel>{`${currentValue}/${maxValue}`}</QuantityLabel>
            {this.props.capacity?.additionalInformation && (
              <Tooltip data-clickable
                toggleElement={this.renderToggle(status)}
                containerElement={this.renderTooltipContent()}
                allowTop={true}>
              </Tooltip>
            )}

          </QuantityAndIconWrapper>
        </QuantityCell>
      </Container>
    );
  };
}

export default Capacity;
